'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setList = setList;
exports.setTitle = setTitle;
exports.setColumns = setColumns;
exports.setItems = setItems;
exports.addItem = addItem;
exports.deleteItem = deleteItem;
var SET_LIST = exports.SET_LIST = 'SET_LIST';
var SET_LIST_TITLE = exports.SET_LIST_TITLE = 'SET_LIST_TITLE';
var SET_LIST_COLUMNS = exports.SET_LIST_COLUMNS = 'SET_LIST_COLUMNS';
var SET_LIST_ITEMS = exports.SET_LIST_ITEMS = 'SET_LIST_ITEMS';
var ADD_LIST_ITEM = exports.ADD_LIST_ITEM = 'ADD_LIST_ITEM';
var DELETE_LIST_ITEM = exports.DELETE_LIST_ITEM = 'DELETE_LIST_ITEM';

function setList(list) {
  return {
    type: SET_LIST,
    payload: list
  };
}

function setTitle(title) {
  return {
    type: SET_LIST_TITLE,
    payload: title
  };
}

function setColumns(columns) {
  return {
    type: SET_LIST_COLUMNS,
    payload: columns
  };
}

function setItems(items) {
  return {
    type: SET_LIST_ITEMS,
    payload: items
  };
}

function addItem(item) {
  return {
    type: ADD_LIST_ITEM,
    payload: item
  };
}

function deleteItem(item) {
  return {
    type: DELETE_LIST_ITEM,
    payload: item
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/ListContainer/actions.js
 ** module id = 472
 ** module chunks = 0
 **/